import Mousetrap from "mousetrap";
import { useEffect, useRef } from "react";

type Handler = ((e: KeyboardEvent) => void) | null | undefined;

type OptionArgs = {
  bindTo?: React.MutableRefObject<HTMLElement | null | undefined>;
};

function useKeyboardShortcut(
  shortcut: string | string[],
  handler: Handler,
  { bindTo }: OptionArgs = {}
) {
  const handlerRef = useRef<Handler>();

  handlerRef.current = handler;

  const bindToElement = bindTo?.current;

  useEffect(() => {
    const mousetrap = bindToElement
      ? new Mousetrap(bindToElement)
      : new Mousetrap();
    mousetrap.stopCallback = () => false;

    mousetrap.bind(shortcut, e => handlerRef.current && handlerRef.current(e));
    return () => {
      mousetrap.unbind(shortcut);
    };
  }, [shortcut, bindToElement]);
}

export { useKeyboardShortcut };
